// extracted by mini-css-extract-plugin
export default {"header":"Headers_header__2Fm7X"};